<template>
	<div id="yagioffer" v-once>


		<!--MV-->
		<section class="hero">
			<div class="hero-deco">
				<img src="/kr/resume/static/yagioffer_img/mv.png" alt="야기오퍼" class="hero-img pc">
				<img src="/kr/resume/static/yagioffer_img/mv-sp.png" alt="야기오퍼" class="hero-img sp">
			</div>
			<div class="wrapper">
				<p class="btn_caption">＼구직활동을 하나로／</p>
				<a href="https://rirekisho.yagish.jp/format/rirekisho_job_new/edit/profile" class="cv-btn">
					<p>야기오퍼에 등록하여<br><span class="cv-btn_txt">이력서를 작성</span></p>
				</a>
			</div>
		</section>

		<!--ヤギオファーとは？-->
		<section class="second">
			<h2 class="second_ti">야기오퍼란?</h2>
			<div class="wrapper second_contents">
				<img src="/kr/resume/static/yagioffer_img/logo_yagioffer.png" alt="야기오퍼로고" class="second_logo">
				<p class="second_lead">졸업생 신입채용 위한 서비스입니다.</p>
				<p class="second_txt">구직자의 경력과 흥미 관심 등을 본 기업에서 채용오퍼를 받을 수 있습니다.<br>
					구직자에게 보내는 오퍼 횟수가 제한 되어 있으므로 기업은 이력서를 확인 한 후<br class="pc"><span class="txt_bold">한건 한건 엄선하여
						오퍼</span>를 보냅니다</p>
				<div class="second_charm">
					<h3>야기오퍼의<span class="txt_color">장점</span></h3>
					<ul class="second_charm_list">
						<li>야기 이력서를 작성 하는 것만으로 사용 할 수 있다.</li>
						<li>구직자에게 관심을 가진 회사에서 직접제안이 온다!</li>
						<li>다양한 업계에서 제안이 올수록 취업 가능성이 높아진다!</li>
					</ul>
					<p class="txt_center">＼덪붙여／</p>
					<p class="txt_center second_charm_last"><span class="txt_border">오퍼를 수락할 때까지 <br class="pc">이름과주소등의
							개인정보는 비공개!<br class="pc"></span>그렇기 때문에 안심!</p>
					<img src="/kr/resume/static/yagioffer_img/rirekisyo.png" alt="履歴書" class="rirekisyo_img">
				</div>
			</div>

			<a href="https://rirekisho.yagish.jp/format/rirekisho_job_new/edit/profile" class="cv-btn">
				<p>야기오퍼에 등록하여<br><span class="cv-btn_txt">이력서를 작성</span></p>
			</a>

		</section>

		<!--使い方-->
		<section class="third">
			<div class="wrapper">
				<h2><img src="/kr/resume/static/yagioffer_img/2step.png" alt="간단!2스텝!"></h2>
				<div class="third_step flex">
					<img src="/kr/resume/static/yagioffer_img/step01.png" alt="이력서입력" class="third_step_item">
					<img src="/kr/resume/static/yagioffer_img/step02.png" alt="입사제안을 받을지는 본인에게 달려있어요!"
						class="third_step_item">
				</div>
				<p class="txt_center third_lead">＼이런 메세지가 도착합니다.／</p>
				<p class="txt_center">마이페이지에서 확인</p>
				<img src="/kr/resume/static/yagioffer_img/offer_exam.png" alt="메세지화면" class="offer_exam_img">
			</div>
		</section>

		<section class="fqa wrapper">
			<h3 class="fqa-ti">자주있는 질문</h3>
			<ul class="fqa-container">
				<li class="fqa-list">
					<h4 class="question">오퍼를 받으면 어떻게 돼?</h4>
					<p class="answer">오퍼를 받은 후 오퍼를 수락하면 해당 기업과 직접 커뮤니케이션을 취할 수 있습니다. 채용설명회를 안내받거나 입사전형으로 진행할 수 있습니다(기업마다
						다름). 오퍼를 보낸 기업에 관심이 없으면 오퍼를 거절할 수도 있습니다.거절한 경우는 해당기업과는 더이상 연락을 할 수 없습니다.</p>
				</li>
				<li class="fqa-list"><!--追加-->
					<h4 class="question">수락 및 거절한 후에는 어떻게 되는건가요?</h4>
					<p class="answer">처음에는 기업이 이력서에서 구직자의 이름과 연락처 등 개인정보를 열람할 수 없는 상태입니다.<br>
						오퍼 수락한 후에는 이력서가 전부 공개되며 직접 소통하게 됩니다.<br>
						또한 거절할 경우 이력서는 공개는 되지 않으며 해당기업은 다시 오퍼를 보낼 수 없습니다.</p>
				</li>
				<li class="fqa-list">
					<h4 class="question">비용은 어떻게 되나요?</h4>
					<p class="answer">무료입니다. 등록 및 모든 기능을 무료로 이용하실 수 있으니 부담없이 이용 해주세요.</p>
				</li>
				<li class="fqa-list">
					<h4 class="question">다른 구직자가 나의 프로필은 보는 것이 가능한가요?</h4>
					<p class="answer">야기오퍼에서 작성한 이력서 정보는 기업만 확인 할 수 있습니다.다른 구직자는 본인 이외의 이력서를 볼 수 없기 때문에 안심하고 마음껏 자신을 어필해
						봅시다.</p>
				</li>
			</ul>
		</section>


		<a href="/kr/resume/format/rirekisho_job_new/edit/profile" class="cv-btn">
			<p>야기오퍼에 등록하고<br><span class="cv-btn_txt">이력서를 작성</span></p>
		</a>

		<div style="text-align: center; padding: 20px;">
			<a href="/kr/resume/yagiofferterms" target="_blank">이용약관<span style="color: #E3165C;">이쪽</span></a>
		</div>

	</div>
</template>
<style lang="css" src="@/assets/css/yagioffer_stylesheet.css"></style>
<style lang="css" src="@/assets/css/yagioffer_reset.css"></style>

<style lang="scss" scoped>
.yo_h2:before {
	display: none;
}
</style>

<script>
export default {
	data: function () {
		return {
			question1: false,
			question2: false,
			question3: false,
			question4: false,
			question5: false,
			question6: false,
			question7: false,
			question8: false
		}
	},
	computed: {},
	methods: {
		viewAnswer: function (name) {
			console.error(name)
			this.question1 = true
		}
	},
	watch: {},
	mounted: function () { }
}
</script>
